import React from "react"
import { useForm, ValidationError } from "@formspree/react"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"
import { TextField, MailField, PhoneField, MessageField, HiddenField, SubmitButton } from "./FormFields"
import { useLocation } from "../../hooks/use-location"
import FormSuccess from "./FormSuccess"
import FormWrapper from "./FormWrapper"

const formId = process.env.GATSBY_SUPPORT_FORM

const Form = () => {
  const { href } = useLocation()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [state, handleSubmit] = useForm(formId, {
    data: { "g-recaptcha-response": executeRecaptcha }
  })

  if (state.succeeded) {
    return (
      <FormSuccess title="¡Ticket enviado!">
        <p>Te contactaremos tan pronto sea posible. Si tienes más dudas envía un correo a <span className="text-bold">soporte@derevo.com.mx</span></p>
      </FormSuccess>
    )
  }

  return (
    <form id="supportform" onSubmit={handleSubmit} className="form-fields">
      <TextField id="name" text="Nombre" required={true} />
      <MailField id="email" text="Correo electrónico" required={true} />
      <PhoneField id="phone" text="Teléfono" />
      <TextField id="company" text="Nombre de la empresa" required={true} />
      <MessageField id="message" text="Por favor, ayúdanos con mas detalles acerca de tu ticket de soporte que necesitas para asignarlo al equipo experto" required={true} />
      <HiddenField id="site" value={href} />
      <HiddenField id="subject" value={`Soporte {{ company }}`} />
      <ValidationError className="errors" errors={state.errors} />
      <SubmitButton text={ state.submitting ? `Enviando...` : `Enviar` } disabled={state.submitting} />
    </form>
  )
}

const SupportForm = (props) => (
  <FormWrapper>
    <Form {...props}/>
  </FormWrapper>
)

export default SupportForm